<template>
  <v-container class="card-wrapper">
    <v-row class="text-center top-shelf">
        <v-col cols="12" sm="2" class="books">
            <Book :image="this.randomisedBooks[0]"/>
            <Book :image="this.randomisedBooks[1]"/>
        </v-col>
        <v-col cols="12" :sm="this.calculateMonitorWidth()" class="top-shelf--filter">
            <div class="outer">
                <div class="inner">
                    <p>Select or deselect subjects to filter our suggestions.</p>
                    <v-combobox
                        v-model="selectedTags"
                        :items="tags"
                        chips
                        clearable
                        label="Filter by subject"
                        multiple
                        solo
                        @change="filterResources"
                    >
                        <template v-slot:selection="{ attrs, item, select, selected }">
                        <v-chip
                            v-bind="attrs"
                            :input-value="selected"
                            close
                            @click="select"
                            @click:close="removeTag(item)"
                            color="tertiary"
                        >
                            <strong>{{ truncate(item.text, 30) }}</strong>&nbsp;
                        </v-chip>
                        </template>
                    </v-combobox>
                </div>
            </div>
            <div class="under"/>
            <div class="stand">
                <MonitorStand/>
            </div>
        </v-col>
        <v-col cols="12" sm="1" class="books">
            <Book :image="this.randomisedBooks[3]"/>
        </v-col>
        <v-col cols="12" sm="2" class="top-shelf--collector">
            <Favorites/>
        </v-col>
        <v-col cols="12" sm="12" class="top-shelf--shelf">
            <div class="top"/>
            <div class="bar"/>
            <div class="brackets">
                <div class="bracket--left"/>
                <div class="bracket--right"/>
            </div>
        </v-col>
    </v-row>
    <v-row>
        <v-container fluid>
            <v-row dense :key="forceRenderKey">
                <v-col
                    v-for="(resource, key, index) in filteredResources"
                    :key="resource.id"
                    :cols="calculateColumnWidth(index)"
                    class="equal--height"
                    >
                    <v-card>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="headline">{{ resource.title }}</v-list-item-title>
                                <v-list-item-subtitle>{{ resource.summary }}</v-list-item-subtitle>
                                <v-list-item-subtitle class="suggested-by"><v-icon color="tertiary">mdi-thumb-up</v-icon> {{ resource.subtitle }}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-avatar color="#e72122"><v-icon color="#fff" v-text="itemAvatar(resource)"></v-icon></v-list-item-avatar>
                        </v-list-item>
                        <v-img
                            :src="getImage(resource)"
                            class="white--text align-end"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            height="200px"
                            >
                        </v-img>
                    
                        <v-card-text class="text--primary">
                            <div :class="resource.body.style" v-html="resource.body.content" />
                        </v-card-text>

                        <div class="quote-mark reversed">
                            <div class="quote-mark--line"> </div>
                            <QuoteImage/>
                        </div>

                        <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-menu
                            bottom
                            origin="center center"
                            transition="scale-transition"
                            >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                color="primary"
                                dark
                                v-bind="attrs"
                                v-on="on"
                                >
                                Take a look
                                </v-btn>
                            </template>
                            <v-list class="resource-list" shaped>
                                <v-subheader class="list-instruction" v-if="resource.type.id == 'book'">Take a look in your school or local library, search the web for it or use the links below.</v-subheader>
                                <v-list-item
                                v-for="(link, key) in resource.links"
                                :key="key"
                                @click="openLink(link)"
                                >
                                <v-list-item-icon><v-icon color="secondary" v-text="resourceIcon(resource)"></v-icon></v-list-item-icon>
                                <v-list-item-content><v-list-item-title>{{ link.title }}</v-list-item-title></v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>

                        <v-btn icon :color="favoriteColor(key)" @click="toggleFavorite(key)">
                            <v-icon>mdi-heart</v-icon>
                        </v-btn>

                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-row>
    <v-row class="text-center bottom-shelf">
        <v-col cols="12" sm="12">
            <BottomShelf/>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
    import { fetchResources } from '../utils/resources'
    import Favorites from './Favorites'
    import Book from './Book'
    import BottomShelf from '../assets/bottom-shelf.svg';
    import MonitorStand from '../assets/monitor-stand.svg';
    import QuoteImage from '../assets/quote.svg';

  export default {
    name: 'CardList',
    components: {
        BottomShelf,
        MonitorStand,
        Book,
        Favorites,
        QuoteImage
    },
    data: () => ({
      resources: {},
      filteredResources: {},
      tags: [],
      selectedTags: [],
      forceRenderKey: 0,
      randomisedBooks: [1,2,3,4,5]
    }),
    mounted() {
        this.init()
    },
    methods: {
        init() {
            let c = this;
            let n = document.querySelector('#nid').getAttribute('data-id');
            fetchResources(n).then(resources => {
                c.resources = resources.data;
                c.filteredResources = resources.data;
                c.generateTags(resources.tags);
                if (resources.wrapper && resources.wrapper.backgroundImageUrl) {
                    this.$store.commit('setBackgroundImage', resources.wrapper.backgroundImageUrl)
                }
            })
            this.randomisedBooks.sort(() => {
                return 0.5 - Math.random();
            });

        },
        generateTags(tags) {
            let t = [];
            Object.entries(tags).forEach(([key, text]) => {
                t.push( {'text': text, 'value': key} );
            });
            t.sort((a, b) => {
                if ('text' in a && 'text' in b) {
                    return a.text > b.text
                }
                return 0;
            })
            this.tags = t;
            this.selectedTags = [...this.tags]
        },
        removeTag(item) {
            this.selectedTags.splice(this.selectedTags.indexOf(item), 1)
            this.selectedTags = [...this.selectedTags]
            this.filterResources()
        },
        filterResources() {
            if (this.selectedTags.length < 1) {
                this.filteredResources = this.resources;
                return;
            }
            let filtered = {}
            let tagNames = [];
            for (const item in this.selectedTags) {
                tagNames.push(this.selectedTags[item].value);
            }
            console.log(tagNames);
            let s = new Set(tagNames);
            Object.entries(this.resources).forEach(([key, resource]) => {
                let rt = resource.tags ? Object.keys(resource.tags) : [];
                let intersect = rt.filter(Set.prototype.has, s);
                if (intersect.length > 0) {
                    filtered[key] = resource;
                }
            })
            this.filteredResources = filtered;
        },
        calculateColumnWidth(index) {
            if (screen.width < 769) {
                return 12;
            }
            if (screen.width > 1280) {
                let m = index%7
                if (m < 3) {
                    return 4
                } else {
                    return 3;
                }
            } else {
                let m = index%5
                if (m < 2) {
                    return 6
                } else {
                    return 4;
                }
            }
            
        },
        calculateMonitorWidth() {
            if (screen.width < 769) {
                return 10;
            } else {
                return 7;
            }
        },
        toggleFavorite(id) {
            if (id in this.$store.state.favorites) {
                this.$store.commit('removeFavorite', id)
            } else {
                this.$store.commit('addFavorite', {id: id, favorite: this.resources[id]})
            }
            this.forceRenderKey = this.forceRenderKey + 1;
        },
        favoriteColor(id) {
            if (id in this.$store.state.favorites) {
                return '#e72122';
            }
            return '';
        },
        getImage(resource) {
            return resource.image && resource.image.url ? resource.image.url : '';
        },
        truncate(str, n) {
            return (str.length > n) ? str.substr(0, n-1) + '...' : str;
        },
        itemAvatar(resource) {
            switch(resource.group_type) {
                case 'watch':
                    return 'mdi-eye';
                case 'listen':
                    return 'mdi-headphones';
                default:
                    return 'mdi-book-open-variant';
            }
        },
        resourceIcon(resource) {
            console.log(resource.type.id);
            switch(resource.type.id) {
                case 'documentary':
                    return 'mdi-video';
                case 'film':
                    return 'mdi-movie';
                case 'youtube':
                    return 'mdi-youtube';
                case 'podcast':
                    return 'mdi-podcast';
                case 'book':
                    return 'mdi-book-open-variant';
                default:
                    return 'mdi-link';
            }
        },
        openLink(resource) {
            if (resource.link) {
                let w = window.open(resource.link, '_blank');
                w.focus();
            }
        }
    },
    computed: {
        
    }
  }
</script>

<style lang="scss" scoped>
.card-wrapper {
    position: relative;
    z-index: 1;
}
.top-shelf {
    min-height: 150px;
    margin-bottom: 20px;
    position: relative;
}
.top-shelf {
    .top-shelf--shelf {
        width: 100%;
        margin-top: -45px;
        .top {
            height: 30px;
            width: 100%;
            background-color: #c4a688;
        }
        .bar {
            height: 15px;
            width: 100%;
            background-color: #b48942;
        }
    }
}

.top-shelf--filter {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    flex-direction: column;
    justify-content: flex-end;
    z-index: 1;
    .outer {
        background-color: #3f3d56;
        padding: 15px;
        border-radius: 5px 5px 0 0;
        width: 100%;
    }
    .inner {
        background-color: #2f2e41;
        padding: 15px;
        border-radius: 3px 3px 0 0;
        > p {
            color: #fff;
        }
    }
    .under {
        background-color: #d0d2d5;
        height: 35px;
        width: 100%;
        border-radius: 0 0 5px 5px;
    }
    .stand {
        display: flex;
        width: 100%;
        justify-content: center;
    }
}
.top-shelf--collector {
    z-index: 1;
}
.bottom-shelf {
    svg {
        width: 100%;
        height: auto;
    }
}
.quote-mark {
    width: 100%;
    height: 35px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 20px;
    margin-bottom: 20px;
    .quote-mark--line {
        width: 100%;
        &:after {
            content: '';
            height: 1px;
            background-color: #b48942;
            width: 60%;
            margin: 0 auto;
            display: block;
        }
    }
    svg {
        height: 100%;
        width: auto;
        margin-top: -35px;
        background-color: white;
        fill: #b48942;
        padding: 5px;
    }
    &.reversed {
        svg {
            transform: rotate(180deg);
        }
    }
}
.equal--height {
    display: flex;
    .v-card {
        padding-bottom: 40px;
        position: relative;
        .v-card__actions {
            position: absolute;
            bottom: 0;
        }
        &:hover {
            .v-list-item__title {
                white-space: normal;
            }
        }
    }
}
.v-card__title {
    font-size: 1.4rem;
}
.text--primary {
    line-height: 1.5;
}
.suggested-by .mdi::before {
    font-size: 20px;
}
.resource-list {
    max-width: 250px;
}
.list-instruction {
    height: auto;
    padding-bottom: 5px;
    border-bottom: 1px solid rgba(0,0,0,0.17);
}
.books {
    display: flex;
    width: 100%;
}


@media (max-width: 768px) {
  .books {
      display: none;
  }
  .v-list-item__title {
      white-space: normal;
  }
}
</style>
